export const TURN_START_NEXT = 'turn.START_NEXT';
export const TURN_FETCHING_NEXT = 'turn.FETCHING_NEXT';
export const TURN_FETCHED_NEXT = 'turn.FETCHED_NEXT';
export const TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH = 'turn.UPDATE_SAVE_CHECKPOINT_AFTER_FETCH';
export const TURN_STATUS_UPDATED = 'turn.STATUS_UPDATED';
export const TURN_HAS_PURCHASED_STOCK_THIS_TURN = 'turn.HAS_PURCHASED_STOCK_THIS_TURN';
export const TURN_SHALL_MISSOUT_ON_CUSTOMERS = 'turn.SHALL_MISSOUT_ON_CUSTOMERS';
